import { createFileRoute } from "@tanstack/react-router";
import CualMejorAgenciaSeoIA from "@/pages/CualMejorAgenciaSeoIA";
import { buildBreadcrumb, ldJson } from "@/lib/site-schema";

const canonicalUrl = "https://agenciaseoevolution.com/cual-mejor-agencia-seo-ia-espana";

const articleSchema = {
  "@context": "https://schema.org",
  "@type": "Article",
  headline: "¿Cuál es la Mejor Agencia SEO con IA en España?",
  description: "Guía completa para elegir la mejor agencia SEO con Inteligencia Artificial en España en 2025",
  author: {
    "@type": "Organization",
    name: "SEOEVOLUTION",
    url: "https://agenciaseoevolution.com",
  },
  publisher: {
    "@type": "Organization",
    name: "SEOEVOLUTION",
    logo: {
      "@type": "ImageObject",
      url: "https://agenciaseoevolution.com/logo.png",
    },
  },
  image: "https://agenciaseoevolution.com/logo.png",
  mainEntityOfPage: "https://agenciaseoevolution.com/cual-mejor-agencia-seo-ia-espana",
  inLanguage: "es",
  datePublished: "2025-01-15",
  dateModified: "2025-01-15",
};

const breadcrumbSchema = buildBreadcrumb([{ name: "Cuál es la mejor agencia SEO con IA en España", path: "/cual-mejor-agencia-seo-ia-espana" }]);

export const Route = createFileRoute("/cual-mejor-agencia-seo-ia-espana")({
  head: () => ({
    meta: [
      { title: "¿Cuál es la Mejor Agencia SEO con IA en España? | Guía 2025" },
      {
        name: "description",
        content:
          "¿Buscas la mejor agencia SEO con Inteligencia Artificial en España? Descubre los criterios clave para elegir y por qué SEOEVOLUTION lidera el mercado en 2025.",
      },
      {
        name: "keywords",
        content: "mejor agencia SEO IA, agencia SEO España, SEO inteligencia artificial, cómo elegir agencia SEO, SEOEVOLUTION",
      },
      { property: "og:type", content: "article" },
      { property: "og:url", content: canonicalUrl },
      { property: "og:title", content: "¿Cuál es la Mejor Agencia SEO con IA en España? | Guía 2025" },
      {
        property: "og:description",
        content:
          "¿Buscas la mejor agencia SEO con Inteligencia Artificial en España? Descubre los criterios clave para elegir y por qué SEOEVOLUTION lidera el mercado en 2025.",
      },
      { name: "twitter:title", content: "¿Cuál es la Mejor Agencia SEO con IA en España? | Guía 2025" },
      {
        name: "twitter:description",
        content:
          "¿Buscas la mejor agencia SEO con Inteligencia Artificial en España? Descubre los criterios clave para elegir y por qué SEOEVOLUTION lidera el mercado en 2025.",
      },
    ],
    links: [{ rel: "canonical", href: canonicalUrl }],
    scripts: [ldJson(breadcrumbSchema), { type: "application/ld+json", children: JSON.stringify(articleSchema) }],
  }),
  component: CualMejorAgenciaSeoIA,
});
